import React from 'react';
import styles from './styles.module.css';
import Home from '../Home';

const fontSessionKey = 'deprescribing-font-size';

type PageContent = (
    | {name: string; link: string; content: string; pages?: undefined}
    | {
          name: string;
          pages: {name: string; link: string; content: string}[];
          link?: undefined;
          content?: undefined;
      }
)[];

type Props = {
    open: boolean;
    onClose: () => void;
};

export default ({open, onClose}: Props) => {
    const [content, setContent] = React.useState<PageContent>([]);

    const commitFontSize = (newSize: string) => {
        document.documentElement.style.fontSize = newSize;
    };

    React.useEffect(() => {
        void import('../../../page-content.json').then(data => {
            setContent(data.default);
        });

        const storedFontSize = sessionStorage.getItem(fontSessionKey);
        if (storedFontSize) {
            commitFontSize(storedFontSize);
        }
    }, []);

    const updateFontSize = (increase: boolean) => {
        const {fontSize} = window.getComputedStyle(document.documentElement);
        const parsedFontSize = Number(
            fontSize.substring(0, fontSize.length - 2),
        );
        const computedFontSize = increase
            ? parsedFontSize + 4
            : parsedFontSize - 4;
        const newFontSize = `${computedFontSize}px`;
        commitFontSize(newFontSize);
        sessionStorage.setItem(fontSessionKey, newFontSize);
    };

    return (
        <div
            className={`${styles.container} ${open ? '' : styles.containerClosed}`}
        >
            <div className={styles.header}>
                <div className={styles.fontContainer}>
                    Font size
                    <button
                        type="button"
                        onClick={() => {
                            updateFontSize(false);
                        }}
                    >
                        -
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            updateFontSize(true);
                        }}
                    >
                        +
                    </button>
                </div>
                <button onClick={onClose} type="button">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="100%"
                        fill="#F7F5E6"
                        className="bi bi-x"
                        viewBox="0 0 16 16"
                    >
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                </button>
            </div>
            <div className={styles.content}>
                {content.map(page => {
                    if (page.pages) {
                        return (
                            <React.Fragment key={page.name}>
                                <a
                                    href={`/about/category-tiles.html#${encodeURIComponent(page.name)}`}
                                >
                                    <h4>{page.name}</h4>
                                </a>
                                {page.pages.map(o => (
                                    <a
                                        href={o.link}
                                        className={styles.menuItem}
                                        key={o.link}
                                    >
                                        {o.name}
                                    </a>
                                ))}
                            </React.Fragment>
                        );
                    }
                    if (page.link.startsWith('/about/')) {
                        return null;
                    }

                    return (
                        <a
                            href={page.link}
                            className={styles.menuItem}
                            key={page.link}
                        >
                            {page.name}
                        </a>
                    );
                })}
                <Home className={styles.homeIcon} />
            </div>
        </div>
    );
};
